export default "__VITE_ASSET__DL48bSgz__"